import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CommandGroup } from '@/components/ui/command';
import { Skeleton } from '@/components/ui/skeleton';
import { selectAccountSlug } from '@/redux/session/selectors';

import { CommandLinkItem } from '../CommandLinkItem';
import { type EntityResult } from '../types';
import { ENTITY_TYPE_LABELS } from '../utils';

type UuidMatchGroupProps = {
  result: EntityResult | null;
  isLoading: boolean;
  onSelect: (path: string, label: string, opts?: { entityType?: string }) => void;
};

export const UuidMatchGroup = ({ result, isLoading, onSelect }: UuidMatchGroupProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);

  if (isLoading) {
    return (
      <CommandGroup heading={t('command_palette.direct_match')} forceMount>
        <div className="flex items-center gap-3 px-2 py-1.5">
          <Skeleton className="size-4 rounded" />
          <Skeleton className="h-4 w-48" />
        </div>
      </CommandGroup>
    );
  }

  if (!result) {
    return null;
  }

  const Icon = result.icon;
  const label = `${t(ENTITY_TYPE_LABELS[result.type])}: ${result.name}`;

  const handleSelect = () => {
    onSelect(result.path, result.name, { entityType: result.type });
  };

  return (
    <CommandGroup heading={t('command_palette.direct_match')} forceMount>
      <CommandLinkItem
        value={`uuid-match-${result.id}`}
        href={slug ? `/${slug}${result.path}` : '#'}
        onSelect={handleSelect}
        forceMount
      >
        <Icon />
        <span className="flex-1 truncate">{label}</span>
      </CommandLinkItem>
    </CommandGroup>
  );
};
